import { css } from "@emotion/react";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

export const root = ({ sizes }: ExactTheme) => css`
  width: 90vw;
  // max-width: ${sizes.width.maxModalWidth};
  height: 90vh;
  padding: 30px 20px;
  overflow: auto;
`;

export const transferList = css`
  height: 100%;
`;
